import { render, staticRenderFns } from "./BetaDiversityDissimilarity.vue?vue&type=template&id=05604c5c&scoped=true"
import script from "./BetaDiversityDissimilarity.vue?vue&type=script&lang=js"
export * from "./BetaDiversityDissimilarity.vue?vue&type=script&lang=js"
import style0 from "./BetaDiversityDissimilarity.vue?vue&type=style&index=0&id=05604c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05604c5c",
  null
  
)

export default component.exports